import { AuthProvider } from 'contexts/AuthContext';
import { NotificaçõesProvider } from 'contexts/NotificaçõesContext';
import { GridProvider } from 'contexts/GridContext';
import { DropsProvider } from 'contexts/DropsContext';
import { IntegracaoProvider } from 'contexts/IntegracaoContext';
import { EntidadesProvider } from 'contexts/EntidadesContext';
import { ProdutosProvider } from 'contexts/ProdutosContext';
import { AnuncioProvider } from './AnuncioContext';
import { ProdutosServicosProvider } from 'contexts/ProdutosServicosContext';
import { AtividadeEntidadeProvider } from 'contexts/AtividadeEntidadeContext';
import { TipoDocumentoProvider } from 'contexts/TipoDocumentoContext';
import { TipoContatoProvider } from 'contexts/TipoContatoContext';
import { TipoEnderecoProvider } from 'contexts/TipoEnderecoContext';
import { TipoParadaProvider } from 'contexts/TipoParadaContext';
import { TipoVinculoProvider } from 'contexts/TipoVinculoContext';
import { ContribuinteProvider } from 'contexts/ContribuinteContext';
import { GrupoEntidadeProvider } from 'contexts/GrupoEntidadeContext';
import { RegiaoEntidadeProvider } from 'contexts/RegiaoEntidadeContext';
import { CidadeProvider } from 'contexts/CidadeContext';
import { UFProvider } from 'contexts/UFContext';
import { PaisProvider } from 'contexts/PaisContext';
import { ClasseCnaeProvider } from 'contexts/ClasseCnaeContext';
import { GrupoCnaeProvider } from 'contexts/GrupoCnaeContext';
import { DivisaoCnaeProvider } from 'contexts/DivisaoCnaeContext';
import { SecaoCnaeProvider } from 'contexts/SecaoCnaeContext';
import { GrupoProdutoProvider } from 'contexts/GrupoProdutoContext';
import { LinhaProdutoProvider } from 'contexts/LinhaProdutoContext';
import { AnpProvider } from 'contexts/AnpContext';
import { MarcaProvider } from 'contexts/MarcaContext';
import { ModeloProvider } from 'contexts/ModeloContext';
import { OrigemTributariaProvider } from 'contexts/OrigemTributariaContext';
import { UnidadeMedidaProvider } from 'contexts/UnidadeMedidaContext';
import { CfiscalProvider } from 'contexts/CfiscalContext';
import { LocalEstoqueProvider } from 'contexts/LocalEstoqueContext';
import { ContasProvider } from 'contexts/ContasContext';
import { FormaDeEnvioProvider } from 'contexts/FormaDeEnvioContext';
import { FormaDePagamentoProvider } from 'contexts/FormaDePagamentoContext';
import { CondicaoDePagamentoProvider } from 'contexts/CondicaoDePagamentoContext';
import { MoedaProvider } from 'contexts/MoedaContext';
import { PlanocontaProvider } from 'contexts/PlanocontaContext';
import { CcustoProvider } from 'contexts/CcustoContext';
import { CcustoValorProvider } from 'contexts/CcustoValorContext';
import { FrotaProvider } from 'contexts/FrotaContext';
import { AplicacaoProvider } from 'contexts/AplicacaoContext';
import { CfoProvider } from 'contexts/CfoContext';
import { SituacaoTributariaProvider } from 'contexts/SituacaoTributariaContext';
import { PrecoProvider } from 'contexts/PrecoContext';
import { ContabilidadeProvider } from 'contexts/ContabilidadeContext';
import { TributacaoProvider } from 'contexts/TributaçãoContext';
import { CrmFunilProvider } from 'contexts/CrmFunilContext';
import { CrmMotivoDescarteProvider } from 'contexts/CrmMotivoDescarteContext';
import { ServicoProvider } from 'contexts/ServicoContext';
import { SerieProvider } from 'contexts/SerieContext';
import { RelatoriosProvider } from 'contexts/RelatoriosContext';
import { DashboardProvider } from 'contexts/DashboardContext';
import { IndicadorQualidadeProvider } from 'contexts/IndicadorQualidadeContext';
import { IndicadorQualidadeRespProvider } from 'contexts/IndicadorQualidadeRespContext';
import { RegraQualidadeProvider } from 'contexts/RegraQualidadeContext';
import { TabelaPrecoProvider } from 'contexts/TabelaPrecoContext';
import {
  DialogProvider,
  ModalProvider,
  DrawerProvider,
} from 'components/Modals';

const Providers = ({ children }) => (
  <AuthProvider>
    <NotificaçõesProvider>
      <GridProvider>
        <DropsProvider>
          <IntegracaoProvider>
            <RelatoriosProvider>
              <EntidadesProvider>
                <ProdutosProvider>
                  <AnuncioProvider>
                    <ProdutosServicosProvider>
                      <AtividadeEntidadeProvider>
                        <TipoDocumentoProvider>
                          <TipoContatoProvider>
                            <TipoEnderecoProvider>
                              <TipoParadaProvider>
                                <IndicadorQualidadeProvider>
                                  <IndicadorQualidadeRespProvider>
                                    <RegraQualidadeProvider>
                                      <TabelaPrecoProvider>
                                        <TipoVinculoProvider>
                                          <ContribuinteProvider>
                                            <GrupoEntidadeProvider>
                                              <RegiaoEntidadeProvider>
                                                <CidadeProvider>
                                                  <UFProvider>
                                                    <PaisProvider>
                                                      <ClasseCnaeProvider>
                                                        <GrupoCnaeProvider>
                                                          <DivisaoCnaeProvider>
                                                            <SecaoCnaeProvider>
                                                              <GrupoProdutoProvider>
                                                                <LinhaProdutoProvider>
                                                                  <AnpProvider>
                                                                    <MarcaProvider>
                                                                      <ModeloProvider>
                                                                        <OrigemTributariaProvider>
                                                                          <UnidadeMedidaProvider>
                                                                            <CfiscalProvider>
                                                                              <LocalEstoqueProvider>
                                                                                <ContasProvider>
                                                                                  <FormaDeEnvioProvider>
                                                                                    <FormaDePagamentoProvider>
                                                                                      <CondicaoDePagamentoProvider>
                                                                                        <MoedaProvider>
                                                                                          <PlanocontaProvider>
                                                                                            <CcustoProvider>
                                                                                              <CcustoValorProvider>
                                                                                                <FrotaProvider>
                                                                                                  <AplicacaoProvider>
                                                                                                    <CfoProvider>
                                                                                                      <SituacaoTributariaProvider>
                                                                                                        <PrecoProvider>
                                                                                                          <ContabilidadeProvider>
                                                                                                            <TributacaoProvider>
                                                                                                              <CrmFunilProvider>
                                                                                                                <CrmMotivoDescarteProvider>
                                                                                                                  <ServicoProvider>
                                                                                                                    <SerieProvider>
                                                                                                                      <DashboardProvider>
                                                                                                                        <ModalProvider>
                                                                                                                          <DialogProvider>
                                                                                                                            <DrawerProvider>
                                                                                                                              {
                                                                                                                                children
                                                                                                                              }
                                                                                                                            </DrawerProvider>
                                                                                                                          </DialogProvider>
                                                                                                                        </ModalProvider>
                                                                                                                      </DashboardProvider>
                                                                                                                    </SerieProvider>
                                                                                                                  </ServicoProvider>
                                                                                                                </CrmMotivoDescarteProvider>
                                                                                                              </CrmFunilProvider>
                                                                                                            </TributacaoProvider>
                                                                                                          </ContabilidadeProvider>
                                                                                                        </PrecoProvider>
                                                                                                      </SituacaoTributariaProvider>
                                                                                                    </CfoProvider>
                                                                                                  </AplicacaoProvider>
                                                                                                </FrotaProvider>
                                                                                              </CcustoValorProvider>
                                                                                            </CcustoProvider>
                                                                                          </PlanocontaProvider>
                                                                                        </MoedaProvider>
                                                                                      </CondicaoDePagamentoProvider>
                                                                                    </FormaDePagamentoProvider>
                                                                                  </FormaDeEnvioProvider>
                                                                                </ContasProvider>
                                                                              </LocalEstoqueProvider>
                                                                            </CfiscalProvider>
                                                                          </UnidadeMedidaProvider>
                                                                        </OrigemTributariaProvider>
                                                                      </ModeloProvider>
                                                                    </MarcaProvider>
                                                                  </AnpProvider>
                                                                </LinhaProdutoProvider>
                                                              </GrupoProdutoProvider>
                                                            </SecaoCnaeProvider>
                                                          </DivisaoCnaeProvider>
                                                        </GrupoCnaeProvider>
                                                      </ClasseCnaeProvider>
                                                    </PaisProvider>
                                                  </UFProvider>
                                                </CidadeProvider>
                                              </RegiaoEntidadeProvider>
                                            </GrupoEntidadeProvider>
                                          </ContribuinteProvider>
                                        </TipoVinculoProvider>
                                      </TabelaPrecoProvider>
                                    </RegraQualidadeProvider>
                                  </IndicadorQualidadeRespProvider>
                                </IndicadorQualidadeProvider>
                              </TipoParadaProvider>
                            </TipoEnderecoProvider>
                          </TipoContatoProvider>
                        </TipoDocumentoProvider>
                      </AtividadeEntidadeProvider>
                    </ProdutosServicosProvider>
                  </AnuncioProvider>
                </ProdutosProvider>
              </EntidadesProvider>
            </RelatoriosProvider>
          </IntegracaoProvider>
        </DropsProvider>
      </GridProvider>
    </NotificaçõesProvider>
  </AuthProvider>
);

export default Providers;
